import { useEffect, useState } from "react";

export function useLocalStrogeState(initialState,key){
    const [value, setValue] = useState(()=>{
    const stroveValue=localStorage.getItem(key);
    return stroveValue? JSON.parse(stroveValue):initialState;
  });

  
  useEffect(function(){
        localStorage.setItem(key,JSON.stringify(value));
  },[value,key])

    return [value,setValue];
}